module.exports = __webpack_public_path__ + "static/media/Step4.08010599.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/pictures/tutorial/Step4.jpg
// module id = 2238
// module chunks = 0